import React from "react";
import PropTypes from "prop-types";
import SectionTitle from "../../components/sectionTitle";
import { Alert, Box } from "@mui/material";
import { useStyles } from "./indexStyles";
import { withStyles } from "@mui/styles";

const UrlError = ({ classes: { formGroup, main } }) => {
  return (
    <Box className={main} m={1} mt={3}>
      <Box container={"true"} justifyContent="center" mt={2}>
        <SectionTitle title={"Check Application Link"} />
        <Box textAlign={"left"}>
          <Box className={formGroup}>
            <Alert severity="error" color="info">
              Oops! It seems there's an error with the application link. Please
              try scanning the QR code once more to continue your journey
              smoothly.
            </Alert>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

UrlError.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles, { withTheme: true })(UrlError);
